// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__11Icn","checkboxCol":"Table_checkboxCol__18Xsu","emailCol":"Table_emailCol__W0GJx","actionCol":"Table_actionCol__3Ujfq"};